import { createContext } from 'react';

interface AccountantContextValue {
  accountantExternalId: string | null;
}

export const AccountantContext = createContext<AccountantContextValue>({
  accountantExternalId: null,
});
